import React from 'react'

import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
} from '@material-ui/core'

import { GenerateSkeleton } from 'components/Table'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const SettingsAccountTable = ({ seller, isLoading }) => {
  const classes = useStyles()

  return !isLoading ? (
    <Table>
      <TableBody>
        <TableRow hover>
          <TableCell>Nome</TableCell>
          <TableCell>{seller.name}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Email</TableCell>
          <TableCell>{seller.email}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Nome fantasia</TableCell>
          <TableCell>{seller.tradeName}</TableCell>
        </TableRow>
        {seller.companyName ? (
          <TableRow hover>
            <TableCell width="30%">Razão social</TableCell>
            <TableCell>{seller.companyName}</TableCell>
          </TableRow>
        ) : null}
        <TableRow hover>
          <TableCell>CPF</TableCell>
          <TableCell>{helpers.people.formatCpf(seller.cpf || '')}</TableCell>
        </TableRow>
        {helpers.people.isCompany(seller.kind) && seller.cnpj ? (
          <TableRow hover>
            <TableCell>CNPJ</TableCell>
            <TableCell>
              {helpers.people.formatCnpj(seller.cnpj || '')}
            </TableCell>
          </TableRow>
        ) : null}
        <TableRow hover>
          <TableCell>Tipo</TableCell>
          <TableCell>{helpers.people.kind(seller.kind)}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Telefone</TableCell>
          <TableCell>{helpers.people.parsePhoneApi(seller.contact)}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Inscrição municipal</TableCell>
          <TableCell>{seller.municipalRegistration}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Código do vendedor</TableCell>
          <TableCell>{seller.code}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Logotipo</TableCell>
          <TableCell>
            {seller.logo ? (
              <img
                src={seller.logo}
                alt="Logotipo do vendedor"
                className={classes.image}
              />
            ) : (
              'Nenhuma imagem enviada'
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  ) : (
    <Table>
      <TableBody>
        <GenerateSkeleton rows={10} cols={2} />
      </TableBody>
    </Table>
  )
}

export default SettingsAccountTable
